import {addCart, deleteCart} from "../../../../state/modules/carts";
import {updateList} from "../../../../state/modules/resources";
import connect from "react-redux/es/connect/connect";

import React from 'react';
import ui from "../../../../util/ui";
import Window from "../../window";
import PaginationArrows from "../../pagination-arrows";
import ButtonGroup from "../../button-group";
import Button from "../../../atoms/button";
import CartListItem from "../cart-list-item";
import List from "../../list";
import OrderCompactListItem from "../../order/order-compact-list-item";
import Grid from "../../grid";
import StatusLabel from "../../../atoms/status-label";
import {fetchActiveRegister, setActiveRegister} from "../../../../state/modules/register";

class CartIndex extends React.Component {
    static defaultProps = {
        onCartClick: () => {
        },
        onOrderClick: () => {
        },
        onRegisterOpenClick: () => {
        },
        onManageRegisterClick: () => {
        },
    };
    
    constructor(props) {
        super(props);
        
        this.state = {
            registerFound: false,
            register: null,
        }
    }
    
    componentDidMount() {
        this.props.fetchActiveRegister();
    }
    
    render() {
        let activeRegisterId = this.props.activeRegister?.id;
        let activeRegister = <Button text={'Open register'} onClick={this.props.onRegisterOpenClick}/>;
        let addCart = null;
        
        if (this.props.activeRegister) {
            activeRegister =
                <Button text={this.props.activeRegister.hid + ' - ' + this.props.activeRegister.location.hid} modifiers={'outline'}
                        onClick={() => this.props.onManageRegisterClick(this.props.activeRegister)}/>
            
            addCart = <Button text="Create new cart"
                              onClick={e => {
                                  this.props.addCart(this.props.activeRegister).then(response => {
                                      if (! response) {
                                          return;
                                      }
                                      let cart = response.result;
                                      this.props.updateList('carts');
                                      this.props.onCartClick(cart);
                                      ui.notify('Cart created');
                                  });
                              }}
            />
        }
        
        let checkoutOrder = <Button text={'Checkout order'} onClick={() => this.props.onCheckoutOrderClick()}/>
        
        return (
            <Grid cols="2fr 1fr">
                <Window
                    title="Open carts"
                    modifiers={'depth'}
                    footer={<PaginationArrows listId={'carts'} model={'carts'}/>}
                    header={
                        <ButtonGroup>
                            {activeRegister}
                            {checkoutOrder}
                            {addCart}
                        </ButtonGroup>
                    }
                >
                    {activeRegisterId && (
                        <List
                            id={'carts'}
                            model={'carts'}
                            filters={{
                                filter_register: [
                                    {key: activeRegisterId}
                                ]
                            }}
                            modifiers={'grid'}
                            selectable={false}
                            onItemClick={cart => this.props.onCartClick(cart)}
                        >
                            <CartListItem
                                onDelete={item => {
                                    this.props.deleteCart(item.id).then(() => {
                                        this.props.updateList('carts');
                                        ui.notify('Cart deleted');
                                    });
                                }}
                            />
                        </List>
                    )}
                </Window>
                <Window modifiers={'depth'} footer={<PaginationArrows listId={'cash-desk-orders'} model={'orders'}/>}>
                    <List
                        id={'cash-desk-orders'}
                        model={'orders'}
                        filters={{
                            filter_type: [
                                {key: 0}
                            ]
                        }}
                        limit={8}
                        sort={{sort_created: 'desc'}}
                        onItemClick={order => this.props.onOrderClick(order)}
                    >
                        <OrderCompactListItem/>
                    </List>
                </Window>
            </Grid>
        );
    }
}

const mapStateToProps = (state) => ({
    carts: state.carts.carts,
    lists: state.resources.lists,
    activeRegister: state.register.activeRegister,
});

const mapDispatchToProps = {
    addCart: addCart,
    updateList: updateList,
    deleteCart: deleteCart,
    fetchActiveRegister: fetchActiveRegister,
};

export default connect(mapStateToProps, mapDispatchToProps)(CartIndex);